import { Auth } from "aws-amplify";
import { environment } from "./Environment";

const env = environment.stage;

Auth.configure({
  cookieStorage: {
    domain: environment.host.domain,
    path: "/",
    expires: null,
    secure: env === "production",
  },
  mandatorySignIn: false,
  userPoolId: environment.outputs.UserPoolId,
  region: environment.outputs.Region,
  userPoolWebClientId: environment.outputs.ClientId,
});
